import { resultsDuckCreator } from 'axl-ducks';
import { pageNames } from '@atc/bonnet-paths';

export default resultsDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
